<template>
  <div class="AiAccommodationDetailsCard">
    <div class="AiAccommodationDetailsCard-informations">
      <div class="AiAccommodationDetailsCard-title">
        <ai-skeleton
          desktop-width="230px"
          desktop-height="24px"
          mobile-width="230px"
          mobile-height="24px"
          :bottom-margin="32" />
      </div>

      <div class="AiAccommodationDetailsCard-facilities">
        <ai-skeleton
          desktop-width="160px"
          desktop-height="12px"
          mobile-width="80px"
          mobile-height="12px"
          :bottom-margin="16" />
        <ai-skeleton
          desktop-width="120px"
          desktop-height="12px"
          mobile-width="130px"
          mobile-height="12px"
          :bottom-margin="16" />
        <ai-skeleton
          desktop-width="160px"
          desktop-height="12px"
          mobile-width="160px"
          mobile-height="12px"
          :bottom-margin="16" />
        <ai-skeleton
          desktop-width="120px"
          desktop-height="12px"
          mobile-width="130px"
          mobile-height="12px"
          :bottom-margin="16" />
        <ai-skeleton
          desktop-width="160px"
          desktop-height="12px"
          mobile-width="160px"
          mobile-height="12px"
          :bottom-margin="48" />
      </div>

      <!-- Prices -->
      <div class="AiAccommodationDetailsCard-pricesWrapper">
        <ai-skeleton
          desktop-width="160px"
          desktop-height="16px"
          mobile-width="160px"
          mobile-height="16px"
          :bottom-margin="24" />

        <ai-skeleton
          desktop-width="70px"
          desktop-height="12px"
          mobile-width="70px"
          mobile-height="10px"
          :bottom-margin="16" />
        <ai-skeleton
          desktop-width="160px"
          desktop-height="16px"
          mobile-width="160px"
          mobile-height="16px"
          :bottom-margin="16" />
        <ai-skeleton
          desktop-width="160px"
          desktop-height="16px"
          mobile-width="160px"
          mobile-height="16px"
          :bottom-margin="24" />
      </div>

      <!-- Actions -->
      <div class="AiAccommodationDetailsCard-action">
        <ai-skeleton
          desktop-width="352px"
          desktop-height="48px"
          mobile-width="100%"
          mobile-height="48px" />
      </div>
    </div>

    <div class="AiAccommodationDetailsCard-carouselWrapper">
      <div class="AiAccommodationDetailsCard-carousel">
        <ai-skeleton
          desktop-width="100%"
          desktop-height="280px"
          mobile-width="100%"
          mobile-height="196px" />
      </div>

      <div class="AiAccommodationDetailsCard-carouselActions">
        <ai-skeleton
          desktop-width="120px"
          desktop-height="16px"
          mobile-width="0px"
          mobile-height="0px" />
        <ai-skeleton
          desktop-width="120px"
          desktop-height="16px"
          mobile-width="0px"
          mobile-height="0px"
          :left-margin="8" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/functions' as func;

.AiAccommodationDetailsCard {
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  width: 100%;
  padding: constants.$padding-01;
  background-color: colors.$white;
  margin-bottom: constants.$margin-02;

  @media (mq.$from-medium) {
    flex-direction: row-reverse;
    gap: constants.$margin-03;
    padding: constants.$padding-03;
  }
}

.AiAccommodationDetailsCard-carouselWrapper {
  @media (mq.$from-medium) {
    flex-basis: 55%;
  }
}

.AiAccommodationDetailsCard-carouselActions {
  display: none;

  @media (mq.$from-medium) {
    display: flex;
    flex-direction: row;
  }
}

.AiAccommodationDetailsCard-carousel {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: constants.$margin-01;
}

.AiAccommodationDetailsCard-informations {
  @media (mq.$from-medium) {
    flex-basis: 45%;
  }
}

.AiAccommodationDetailsCard-title {
  margin-bottom: constants.$margin-01;
}

.AiAccommodationDetailsCard-facilities {
  display: flex;
  flex-direction: column;

  gap: 0;

  @media (mq.$from-medium) {
    flex-wrap: wrap;
    flex-direction: row;
    margin-bottom: constants.$margin-00;
    column-gap: constants.$margin-02;
  }
}

.AiAccommodationDetailsCard-seeDetails {
  margin-bottom: constants.$margin-03;

  @media (mq.$from-medium) {
    margin-bottom: constants.$margin-02;
  }
}
</style>
